import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import { StaticQuery, graphql } from 'gatsby'
import { BreakpointsProvider } from 'react-with-breakpoints'
import { Location } from '@reach/router'

import Header from 'components/common/header'
import Footer from 'components/common/footer'
import 'sass/main.scss'

const breakpoints = {
    xlarge:Infinity,
    large:1280,
    medium:980,
    small:736,
    xsmall:480,
    xxsmall:360
}


const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            shorttitle
          }
        }
      }
    `}
    render={data => (
      <>
      <BreakpointsProvider breakpoints={breakpoints}>
        <Helmet>
          <html lang="it" />
          <meta name="robots" content="all" />
          <meta name="revisit-after" content="10" />
          <meta name="language" content="it-IT" />
          <meta name="charset" content="utf-8" />
          <meta name="copyright" content="http://creativecommons.org/licenses/by-nc-nd/4.0/" />
          <meta name="author" content="Giovanni Gadaleta" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
          <meta name="B-verify" content="a8cec677f67cc79dadd2b60d1d640d8bcfe46c37" />
          <script id="Cookiebot" src="https://consent.cookiebot.com/uc.js" data-cbid="6cfefb24-bc45-488c-b6fa-5ae01ddd491a" type="text/javascript" async></script>
          <script>
          {`
          function CookiebotCallback_OnAccept(){Cookiebot.consent.statistics&&enableGoogleAnalytics()}var _gaq=[];function enableGoogleAnalytics(){_gaq.push(["_setAccount","UA-129013048-1"]),_gaq.push(["_trackPageview"]),function(){var t=document.createElement("script");t.type="text/javascript",t.async=!0,t.src=("https:"==document.location.protocol?"https://ssl":"http://www")+".google-analytics.com/ga.js";var e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(t,e);var k=document.createElement("script");k.type="text/javascript";k.async=!0;k.src=("https:"==document.location.protocol?"https://":"http://")+"platform-api.sharethis.com/js/sharethis.js#property=5c608dfd58b9770011925cee&product=inline-share-buttons";var j=document.getElementsByTagName("script")[0];j.parentNode.insertBefore(k,j);}()}
          `}
          </script>        
        </Helmet>
        <div id="wrapper" className="divided">
          <Location>
            {({ location }) => {
              if(location.pathname !== '/' && location.pathname !== '/gadaabout/') {
                return <Header siteTitle={data.site.siteMetadata.shorttitle} />
              }
              return null
            }}
          </Location>
          {children}
          <Footer/>
        </div>
      </BreakpointsProvider>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
